'use client';

import { Suspense } from 'react';
import { RecurringBreakdownView } from '@/components/recurring-payments/RecurringBreakdownView';
import { PageSkeleton } from '@/components/PageSkeleton';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';
import { useChatPage } from '@/hooks/useChatPage';

export default function RecurringPaymentsBreakdownPage() {
  useChatPage('recurring-payments');
  return (
    <>
      <AppHeaderConfig hidePeriodPicker />
      <Suspense fallback={<PageSkeleton />}>
        <RecurringBreakdownView />
      </Suspense>
    </>
  );
}
